import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import connect from './landing.connector';
import { t } from '../i18n';
import { BrandIcon } from '../tornado/brand-icon/brandIcon.component';
import HeroOverlay from '../tornado/hero/heroOverlay/heroOverlay.component';
import { LandingButtons } from './landingButtons/landingButtons.component';
import { getInitialStyle } from './landing.style';
import { landingShown } from '../../logic/routing/routing.actions';
import { removeSplashScreen } from '../../logic/app/app.utils';
import { navigateTo, SSI_PATH } from '../routes/routes.utils';
import { shouldNavigateToSingleSignIn } from './landing.utils';

export class Landing extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Root: {
          Background: {},
          Overlay: {
            type: HeroOverlay,
          },
          Content: {
            Logo: {
              type: BrandIcon,
              testId: 'CustomerLogo',
            },
            CatchPhrase: {
              text: {
                text: t('pairing.landing.catchPhrase'),
              },
            },
            Description: {
              text: {
                text: t('pairing.landing.description'),
              },
            },
            Pricing: {
              text: {
                text: t('pairing.landing.pricing'),
              },
            },
            Buttons: {
              type: LandingButtons,
            },
          },
        },
        testId: 'Landing',
      },
      getInitialStyle(),
    );
  }

  _build() {
    const background = this.tag('Background');

    background.once('txLoaded', () => {
      background.setSmooth('alpha', 1);
      background.setSmooth('scale', 1, { duration: 0.5 });
    });
  }

  _attach() {
    Store.dispatch(landingShown());
  }

  async _active() {
    const proceedWithSSI = await shouldNavigateToSingleSignIn();

    removeSplashScreen();

    if (proceedWithSSI) {
      navigateTo(SSI_PATH);
    } else {
      this.tag('Root').visible = true;
      this._unsubscribe = connect(this);
    }
  }

  _inactive() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }

  _detach() {
    this.tag('Background').removeAllListeners('txLoaded');
  }

  set isUnpairedEntering(value) {
    const text = value ? t('pairing.landing.connect') : t('pairing.landing.pricing');
    this.tag('Pricing').text.text = text;
  }

  _getFocused() {
    return this.tag('Buttons');
  }
}
